import React, { FC } from 'react';
import AdminUsersList from '@/components/Admin/AdminUsers/AdminUsersList';

export const AdminToolsView: FC = () => {
  return <AdminUsersList />;
};

export default AdminToolsView;
